import { useEffect } from 'react';
export const useMutationObserver = (callback, ref, options = {
    attributes: true,
    characterData: true,
    childList: true,
    subtree: true,
}) => useEffect(() => {
    if (ref?.current == null)
        return () => null;
    const observer = new MutationObserver(callback);
    observer.observe(ref.current, options);
    return () => observer.disconnect();
}, [callback, options, ref?.current]);
//# sourceMappingURL=use-mutation-observer.js.map